import { normalizeApiError } from '../api/apiError';
import { createReadAsyncThunk } from "../store/createReadAsyncThunk";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Donations } from '../api/endpoints/donationsApi';
import { ApiRequestStatus } from "../enums/apiRequestStatus";
import { CreateDonationBasketCommand } from "../models/donation/createDonationBasketCommand";
import { Commitment } from "../models/donation/commitment";

interface famState {
    basketId: string | null;
    donationDetails: Commitment[] | null;

    donationDetailsStatus: ApiRequestStatus;
    submitDonationDetailsStatus: ApiRequestStatus;
}

const initialState: famState = {
    basketId: null,
    donationDetails: null,
    
    donationDetailsStatus: ApiRequestStatus.Idle,
    submitDonationDetailsStatus: ApiRequestStatus.Idle
}

export const submitToBasketAsync = createAsyncThunk<string, CreateDonationBasketCommand>(
    'donations/submitToBasketAsync',
    async (donationCommand, thunkAPI) => {
        try {
            return await Donations.submitToBasketAsync(donationCommand);
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const getCommitmentsAsync = createReadAsyncThunk<Commitment[]>(
    'donations/getCommitmentsAsync',
    async (_, thunkAPI) => {
        try {
            return await Donations.getCommitmentsAsync();
        } catch (error: unknown) {
            return thunkAPI.rejectWithValue(normalizeApiError(error));
        }
    }
)

export const donationsSlice = createSlice({
    name: 'donationsSlice',
    initialState,
    reducers: {

    },
    extraReducers: (builder => {
        builder.addCase(getCommitmentsAsync.pending, (state) => {
            state.donationDetailsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(getCommitmentsAsync.fulfilled, (state, action) => {
            state.donationDetails = action.payload;
            state.donationDetailsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(getCommitmentsAsync.rejected, (state) => {
            state.donationDetailsStatus = ApiRequestStatus.Rejected;
        });

        builder.addCase(submitToBasketAsync.pending, (state) => {
            state.submitDonationDetailsStatus = ApiRequestStatus.Pending;
        });
        builder.addCase(submitToBasketAsync.fulfilled, (state, action) => {
            state.basketId = action.payload;
            state.submitDonationDetailsStatus = ApiRequestStatus.Fulfilled;
        });
        builder.addCase(submitToBasketAsync.rejected, (state) => {
            state.submitDonationDetailsStatus = ApiRequestStatus.Rejected;
        });
    })
})
